import React, { lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import { Provider } from 'react-redux';
import store from './store';
import './index.css';
import { AnimationProvider } from "./AnimationContext";
import { Loading } from './Components';

const App = lazy(() => import('./App'));

document.addEventListener('DOMContentLoaded', () => {
    const root = createRoot(document.getElementById('root'));
    root.render(
        <Provider store={store}>
            <AnimationProvider>
                <Suspense fallback={<Loading />}>
                    <BrowserRouter>
                        <App />
                    </BrowserRouter>
                </Suspense>
            </AnimationProvider>
        </Provider>
    );
});